// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-info {
  background: #faf7f6;
}

.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3019607843);
}

.logo {
  --icon-color: black;
  height: 36px;
  width: 85px;
  margin-bottom: 20px;
}

.title {
  font-family: Title;
  font-size: 32px;
  line-height: 110%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  vertical-align: baseline;
}
.title.accent {
  color: #c6a475;
}

.container-all {
  height: 100vh;
}
.container-all .wrapper-left {
  display: flex;
  justify-content: center;
  align-self: center;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #faf7f6;
}
.container-all .wrapper-left ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.container-all.wrapper-info {
  overflow: auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.container-all.wrapper-info ion-button {
  width: 100%;
  text-wrap: auto;
}
.container-all.wrapper-info .main-card {
  flex-grow: 1;
  margin: 16px 16px 0;
  background: #fff;
  border-radius: 9px 9px 0 0;
}
.container-all.wrapper-info ion-card {
  text-align: initial;
  border: none;
  box-shadow: none;
  background: transparent;
  --color: var(--color-black);
  --preorder-type-chip-border-color: var(--ion-color-primary);
  overflow: auto;
  word-break: break-word;
}
.container-all.wrapper-info ion-card ion-card-header {
  background: white;
  color: var(--color-black);
  padding: 0;
  padding-bottom: 8px;
  border-bottom: 0.3px solid rgba(126, 167, 105, 0.4509803922);
}
.container-all.wrapper-info ion-card ion-card-header .separator {
  margin-block: 20px;
}
.container-all.wrapper-info ion-card ion-card-header ion-button {
  --background: transparent;
  --color: #54504c;
  text-transform: none;
}
.container-all.wrapper-info ion-card ion-card-content {
  border-top: 0.3px solid rgba(126, 167, 105, 0.4509803922);
  padding: 10px 0px 0px 0px;
  line-break: auto !important;
}
.container-all.wrapper-info ion-card ion-card-content:first-of-type {
  border: none;
}
.container-all.wrapper-info ion-card ion-card-content .padding-card {
  padding: 10px;
}
.container-all.wrapper-info ion-card ion-card-title {
  font-family: AppFontBold, sans-serif;
  color: var(--color-black);
  font-size: 18px;
}
.container-all.wrapper-info ion-card .icon-edit {
  zoom: 1.3;
}
.container-all.wrapper-info ion-card .left-col {
  text-align: left;
}
.container-all.wrapper-info ion-card .right-col {
  text-align: right;
}

.item-row {
  padding: 15px 15px 25px;
  border-bottom: 1px solid #ebdfda;
}

.article-price,
.article-name {
  margin-bottom: 10px;
}

.article-name {
  padding: 0;
  font-family: Title;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 2%;
  vertical-align: middle;
  text-transform: uppercase;
}

.article-price {
  padding: 0;
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 2%;
  vertical-align: middle;
  text-transform: uppercase;
}

.option-block {
  padding: 0;
}

.option-name {
  font-family: AppFont;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: bottom;
  text-transform: uppercase;
  margin-bottom: 3px;
}

.footer {
  margin-top: 2px;
  border-top: 1px solid rgba(0, 0, 0, 0.3019607843);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.table-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3019607843);
}
.table-row .table-title,
.table-row .table-sum {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.total-row {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  padding: 10px 18px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3019607843);
}
.total-row .total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  width: 100%;
}
.total-row .total-title,
.total-row .total-sum {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.sub-total {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-bottom: 8px;
}
.sub-total .sub-total-title,
.sub-total .sub-total-sum {
  font-family: AppFont;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 8%;
  vertical-align: middle;
  text-transform: uppercase;
}

.button-block {
  width: 100%;
  padding: 25px 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oDAAA;AADD;;AAIA;EACC,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AADD;;AAIA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;AADD;AAGC;EACC,cAAA;AADF;;AAKA;EACC,aAAA;AAFD;AAGC;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AADF;AAEE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAAH;AAMC;EACC,cAAA;EAMA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AATF;AACE;EACC,WAAA;EACA,eAAA;AACH;AAOE;EACC,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;AALH;AAQE;EACC,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2DAAA;EACA,cAAA;EACA,sBAAA;AANH;AAOG;EACC,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,mBAAA;EAIA,4DAAA;AARJ;AAKI;EACC,kBAAA;AAHL;AAOI;EACC,yBAAA;EACA,gBAAA;EACA,oBAAA;AALL;AAQG;EACC,yDAAA;EAEA,yBAAA;EACA,2BAAA;AAPJ;AAQI;EACC,YAAA;AANL;AAQI;EACC,aAAA;AANL;AASG;EACC,oCAAA;EACA,yBAAA;EACA,eAAA;AAPJ;AASG;EACC,SAAA;AAPJ;AAWG;EACC,gBAAA;AATJ;AAYG;EACC,iBAAA;AAVJ;;AAgBA;EACC,uBAAA;EACA,gCAAA;AAbD;;AAgBA;;EAEC,mBAAA;AAbD;;AAgBA;EACC,UAAA;EAEA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAdD;;AAiBA;EACC,UAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAfD;;AAiBA;EACC,UAAA;AAdD;;AAiBA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAdD;;AAiBA;EACC,eAAA;EACA,iDAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAdD;;AAiBA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,oDAAA;AAdD;AAeC;;EAEC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAbF;;AAiBA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,oDAAA;AAdD;AAgBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;AAdF;AAiBC;;EAEC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAfF;;AAmBA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAhBD;AAiBC;;EAEC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAfF;;AAmBA;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAhBD","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper-info {\n\tbackground: #faf7f6;\n}\n\n.header {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 30px 0 20px;\n\tborder-bottom: 1px solid #0000004d;\n}\n\n.logo {\n\t--icon-color: black;\n\theight: 36px;\n\twidth: 85px;\n\tmargin-bottom: 20px;\n}\n\n.title {\n\tfont-family: Title;\n\tfont-size: 32px;\n\tline-height: 110%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tvertical-align: baseline;\n\n\t&.accent {\n\t\tcolor: #c6a475;\n\t}\n}\n\n.container-all {\n\theight: 100vh;\n\t.wrapper-left {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-self: center;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\toverflow: auto;\n\t\tbackground: #faf7f6;\n\t\tion-img {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t\t// background: url('') no-repeat center center / 105% 105%;\n\t\t// background-size: cover;\n\t\t// background-position: center;\n\t}\n\t&.wrapper-info {\n\t\toverflow: auto;\n\t\tion-button {\n\t\t\twidth: 100%;\n\t\t\ttext-wrap: auto;\n\t\t}\n\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-direction: column;\n\n\t\t.main-card {\n\t\t\tflex-grow: 1;\n\t\t\tmargin: 16px 16px 0;\n\t\t\tbackground: #fff;\n\t\t\tborder-radius: 9px 9px 0 0;\n\t\t}\n\n\t\tion-card {\n\t\t\ttext-align: initial;\n\t\t\tborder: none;\n\t\t\tbox-shadow: none;\n\t\t\tbackground: transparent;\n\t\t\t--color: var(--color-black);\n\t\t\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\t\t\toverflow: auto;\n\t\t\tword-break: break-word;\n\t\t\tion-card-header {\n\t\t\t\tbackground: white;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tpadding: 0;\n\t\t\t\tpadding-bottom: 8px;\n\t\t\t\t.separator {\n\t\t\t\t\tmargin-block: 20px;\n\t\t\t\t}\n\t\t\t\tborder-bottom: 0.3px solid #7ea76973;\n\n\t\t\t\tion-button {\n\t\t\t\t\t--background: transparent;\n\t\t\t\t\t--color: #54504c;\n\t\t\t\t\ttext-transform: none;\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-card-content {\n\t\t\t\tborder-top: 0.3px solid #7ea76973;\n\n\t\t\t\tpadding: 10px 0px 0px 0px;\n\t\t\t\tline-break: auto !important;\n\t\t\t\t&:first-of-type {\n\t\t\t\t\tborder: none;\n\t\t\t\t}\n\t\t\t\t.padding-card {\n\t\t\t\t\tpadding: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-card-title {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tfont-size: 18px;\n\t\t\t}\n\t\t\t.icon-edit {\n\t\t\t\tzoom: 1.3;\n\t\t\t}\n\t\t\tion-col {\n\t\t\t}\n\t\t\t.left-col {\n\t\t\t\ttext-align: left;\n\t\t\t}\n\n\t\t\t.right-col {\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.item-row {\n\tpadding: 15px 15px 25px;\n\tborder-bottom: 1px solid #ebdfda;\n}\n\n.article-price,\n.article-name {\n\tmargin-bottom: 10px;\n}\n\n.article-name {\n\tpadding: 0;\n\n\tfont-family: Title;\n\tfont-size: 16px;\n\tline-height: 120%;\n\tletter-spacing: 2%;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n}\n\n.article-price {\n\tpadding: 0;\n\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n\tline-height: 120%;\n\tletter-spacing: 2%;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n}\n.option-block {\n\tpadding: 0;\n}\n\n.option-name {\n\tfont-family: AppFont;\n\tfont-size: 10px;\n\tline-height: 120%;\n\tletter-spacing: 0%;\n\tvertical-align: bottom;\n\ttext-transform: uppercase;\n\tmargin-bottom: 3px;\n}\n\n.footer {\n\tmargin-top: 2px;\n\tborder-top: 1px solid #0000004d;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.table-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 10px 18px;\n\tborder-bottom: 1px solid #0000004d;\n\t.table-title,\n\t.table-sum {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.total-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 0;\n\tpadding: 10px 18px;\n\tborder-bottom: 1px solid #0000004d;\n\n\t.total {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tpadding: 0;\n\t\twidth: 100%;\n\t}\n\n\t.total-title,\n\t.total-sum {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.sub-total {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 0;\n\tmargin-bottom: 8px;\n\t.sub-total-title,\n\t.sub-total-sum {\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 8%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.button-block {\n\twidth: 100%;\n\tpadding: 25px 14px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
